import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { getFormPdf } from 'actions';

import NotFoundPage from 'components/Errors/NotFoundPage';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class OriginalPdfForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape().isRequired,
    isFetchingPdfForm: PropTypes.bool,
    // eslint-disable-next-line
    pdfFile: PropTypes.any,
    getFormPdfError: PropTypes.shape({})
  };

  static defaultProps = {
    isFetchingPdfForm: false,
    pdfFile: null,
    getFormPdfError: null
  };

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params: { formId } } = match;
    dispatch(getFormPdf({ id: formId, IsAdditional: false }));
  }

  render() {
    const {
      isFetchingPdfForm,
      pdfFile,
      getFormPdfError
    } = this.props;
    return (
      <div className="original-pdf-form">
        { !getFormPdfError && pdfFile != null && <div className="progress-wrapper">
          {
            // eslint-disable-next-line
            isFetchingPdfForm
              ? <progress className="progress" max="100" />
              : <object
                  data={ pdfFile.blob }
                  type="application/pdf"
                  width="100%"
                  height="100%"
              >
                Cannot display inline PDF document. Try to
                <a href={ pdfFile.blob } download>download</a>
                it
              </object>
          }
        </div> }
        { getFormPdfError && <div className="page">
          <div className="page-body">
            <NotFoundPage caption="The PDF form was not found" />
          </div>
        </div> }
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { forms: {
    isFetchingPdfForm,
    pdfFile,
    getFormPdfError
  } } = state;
  return {
    isFetchingPdfForm,
    pdfFile,
    getFormPdfError
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(OriginalPdfForm, 'OriginalPdfForm'));
